export const CACHE_KEY = {
  articles: "/api/articles*",
  startupConfigs: "/api/configs/startup*",
  seo: "/api/seo*",
  redirects: "/api/redirects*",
  instruments: "/api/instrument*",
  socialMedia: "/api/social-media*",
  depositAndWithdrawal: "/api/dw*",
  analyses: "/api/analyses*",
  helpCenter: "/api/help-center*",
  videos: "/api/videos*",
  terms: "/api/terms*",
  partnershipIb: "/api/partnership/language*",
  aboutUs: "/api/about-us*",
  marginCalculator: "/api/mc/language*",
  profitAndLossCalculator: "/api/plc/language*",
  spreadCalculator: "/api/sc/language*",
  accountType: "/api/account-type/*",
  contactUs: "/api/contact-us*",
  heroBanner: "/api/hero-banner*",
  contestPromotions: "/api/contest-promotions*",
  contestView: "/api/contest-view*",

  // should review this parts
  servicesSection: "/api/services-section",
  paymentMethod: "/api/payment-methods",
}